import React, {
  Fragment,
  useCallback,
  useEffect,
  useState,
  useMemo,
} from "react";
import axios from "axios";
import { baseURL } from "../../constants/pathnames";
import { useSelector } from "react-redux";
import Dropdown from "react-dropdown";
import Button from "../Button/Button";
import Input from "../Input/Input";
import { arrow_down, arrow_up } from "../../constants/data";
import {
  moblieNumber,
  mobileChecker,
  regularPhoneNumber,
} from "../../constants/services";
const ModalEditProfile = ({ onCancel, data, getdata }) => {
  console.log(data);
  const { token } = useSelector((state) => state.users);
  const header = useMemo(() => {
    const headers = {
      headers: {
        Authorization: `jwt ${token}`,
      },
    };
    return headers;
  }, [token]);

  const [loader, setLoader] = useState(false);
  const [provinceDropdown, setProvinceDropdown] = useState([]);
  const [cityDropdown, setCityDropdown] = useState([]);

  const [name, setname] = useState(data?.first_name);
  const [nameError, setnameError] = useState("");

  const [lastname, setlastname] = useState(data?.last_name);
  const [lastnameError, setlastnameError] = useState("");

  const [username, setUsername] = useState(data?.username);
  const [usernameError, setUsernameError] = useState("");

  const [phone, setPhone] = useState(moblieNumber(data?.phone_number, 2));
  const [phoneNumberError, setPhoneNumberError] = useState("");

  const [province, setProvince] = useState({
    label: data?.province_detail?.name,
    value: data?.province_detail?.id,
  });
  // const [provinceError, setProvinceError] = useState("");

  const [city, setCity] = useState({
    label: data?.city_detail?.name,
    value: data?.city_detail?.id,
  });
  // const [cityError, setCityError] = useState("");

  const [email, setEmail] = useState(data?.email);
  const [emailError, setEmailError] = useState("");

  useEffect(() => {
    const overlay = document.querySelector(".modal-overlay");
    const listener = (event) => {
      if (overlay) {
        onCancel();
      }
    };
    overlay.addEventListener("click", listener);
  });

  ////////////////////////////////
  const getProvinces = () => {
    axios
      .get(`${baseURL}auth/provinces/`)
      .then((res) => {
        setProvinceDropdown(
          res.data.map((item) => ({ label: item.name, value: item.id }))
        );
      })
      .catch((err) => {});
  };
  const getCities = (id) => {
    axios
      .get(`${baseURL}auth/cities/${id}/`)
      .then((res) => {
        console.log(res.data);
        setCityDropdown(
          res.data.map((item) => ({ label: item.name, value: item.id }))
        );
      })
      .catch((err) => {});
  };
  useEffect(() => {
    getProvinces();
    setname(data?.user?.first_name);
    setlastname(data?.user?.last_name);
    setUsername(data?.user?.username);
    setProvince({
      value: data?.province_detail?.id,
      label: data?.province_detail?.name,
    });
    setCity({
      value: data?.city_detail?.id,
      label: data?.city_detail?.name,
    });
    setEmail(data?.user?.email);
  }, [data]);
  useEffect(() => {
    if (province !== null) getCities(province?.value);
  }, [province]);
  /////////////////////////////////

  const handleEdit = useCallback(() => {
    setLoader(true);
    const patchdata = {
      city: city?.value,
    };

    if (data?.user?.first_name !== name) patchdata["first_name"] = name;
    if (data?.user?.last_name !== lastname) patchdata["last_name"] = lastname;
    if (data?.user?.username !== username) patchdata["username"] = username;
    if (data?.user?.phone_number !== parseInt(regularPhoneNumber(phone))) {
      if (phone.length === 0) {
        setPhoneNumberError("ورود شماره‌ی همراه الزامی است");
      } else if (phone.length < 10) {
        setPhoneNumberError("شماره‌ی همراه باید 11 رقم باشد");
      } else if (!mobileChecker(phone)) {
        setPhoneNumberError("شماره‌ی همراه را به درستی وارد کنید");
      } else {
        patchdata["phone_number"] = regularPhoneNumber(phone);
      }
    }
    if (data?.user?.email !== email) patchdata["email"] = email;

    debugger;

    axios
      .patch(`${baseURL}auth/panel/update/${data.id}/`, patchdata, header)
      .then((res) => {
        setLoader(false);
        getdata();
        onCancel();
      })
      .catch((err) => {
        setLoader(false);
        const emailerr = err?.response?.data?.user?.email;
        if (
          emailerr?.includes("user with this email address already exists.")
        ) {
          setEmailError("کاربر دیگری با این ایمیل وجود دارد ");
        }
        const username = err?.response?.data?.user?.username;
        if (
          username?.includes(
            "Enter a valid username starting with a-z. This value may contain only letters, numbers and underscore characters."
          )
        ) {
          setUsernameError("نام کاربری معتبر وارد کنید. ");
        }
        if (username?.includes("A user with that username already exists.")) {
          setUsernameError("کاربر دیگری با این نام کاربری وجود دارد ");
        }

        console.log(username);
      });
  }, [
    header,
    name,
    lastname,
    username,
    email,
    city,
    data,
    // history,
    getdata,
    onCancel,
    phone,
  ]);

  return (
    <Fragment>
      <div
        style={{ zIndex: "100000" }}
        className='fixed  inset-0 overflow-y-auto'
        aria-labelledby='modal-title'
        role='dialog'
        aria-modal='true'
      >
        <div
          className='flex items-center justify-center min-h-screen p-4 text-center sm:block sm:p-0 transition-opacity ease-in duration-300'
          // transition-opacity ease-in duration-300
          style={{ transition: "opacity 0.25s ease" }}
        >
          <div
            className='fixed inset-0 bg-gray-500 bg-opacity-50  modal-overlay'
            aria-hidden='true'
            // ref={ref}
          ></div>

          <span
            className='hidden sm:inline-block align-middle sm:h-screen'
            aria-hidden='true'
          >
            &#8203;
          </span>

          <div className=' inline-block bg-white rounded-2xl overflow-hidden shadow-xl transform transition-all sm:my-8 align-middle sm:max-w-3xl w-full '>
            <div className='bg-white text-right px-4 md:max-w-lg mx-auto'>
              <img
                className='m-2 absolute left-4 top-4'
                src='/statics/images/close.svg'
                width='16px'
                height='16px'
                alt='arrow'
                onClick={() => {
                  onCancel();
                }}
              />

              <div className='my-10'>
                <div className='font-semibold text-lg text-center mb-10'>
                  ویرایش حساب کاربری
                </div>

                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 '>
                  <Input
                    title='نام'
                    placeholder=''
                    maxWidth='100%'
                    value={name}
                    error={nameError}
                    type='text'
                    input
                    onChange={(event) => {
                      let { value } = event.target;
                      setname(value);
                      setnameError("");
                    }}
                  />
                  <Input
                    title='نام خانوادگی'
                    placeholder=''
                    maxWidth='100%'
                    value={lastname}
                    error={lastnameError}
                    type='text'
                    input
                    onChange={(event) => {
                      let { value } = event.target;
                      setlastname(value);
                      setlastnameError("");
                    }}
                  />
                </div>

                <Input
                  title='لطفا نام کاربری را وارد کنید.'
                  placeholder='مثال:  ali'
                  // maxWidth='100%'
                  value={username}
                  error={usernameError}
                  type='text'
                  input
                  onChange={(event) => {
                    let { value } = event.target;
                    setUsername(value);
                    setUsernameError("");
                  }}
                  margin='0 0 16px 0'
                />

                <Input
                  title='لطفا شماره موبایل را وارد کنید.'
                  placeholder='مثال:  ali'
                  // maxWidth='100%'
                  value={phone}
                  error={phoneNumberError}
                  type='text'
                  input
                  onChange={(event) => {
                    let { value } = event.target;
                    setPhone(value);
                    setPhoneNumberError("");
                  }}
                  margin='0 0 16px 0'
                />

                {/* <div className='w-full'> */}
                <div className='font-semibold my-1'>
                  لطفا استان و شهر را مشخص کنید.{" "}
                  {/* <span className='color-red px-1'>*</span> */}
                </div>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 '>
                  <div className='relative'>
                    <Dropdown
                      id={0}
                      className='w-full rounded-lg shadow-md border-gray-300 border'
                      controlClassName='py-2 flex justify-between w-full'
                      menuClassName=''
                      arrowClosed={arrow_down}
                      arrowOpen={arrow_up}
                      options={provinceDropdown}
                      onChange={(val) => {
                        setProvince(val);
                        setCity(null);
                      }}
                      // value={categoryDropdown[0]}
                      placeholder={
                        province !== null ? province.label : "انتخاب استان"
                      }
                    />
                    {/* <div className='color-red font-10  absolute left-4 top-8 bg-white px-2'>
                      {provinceError}
                    </div> */}
                  </div>

                  <div className='relative'>
                    <Dropdown
                      id={1}
                      className='w-full rounded-lg shadow-md border-gray-300 border'
                      controlClassName='py-3 flex justify-between w-full'
                      menuClassName=''
                      arrowClosed={arrow_down}
                      arrowOpen={arrow_up}
                      options={cityDropdown}
                      onChange={(val) => {
                        setCity(val);
                      }}
                      value={city !== null && city.label}
                      placeholder='انتخاب شهر'
                    />
                    {/* <div className='color-red font-10  absolute left-4 top-8 bg-white px-2'>
                      {cityError}
                    </div> */}
                  </div>
                </div>
                {/* </div> */}

                <Input
                  title='لطفا پست الکترونیکی خود را وارد کنید.'
                  placeholder='example@gmail.com'
                  // maxWidth='100%'
                  value={email}
                  error={emailError}
                  type='text'
                  input
                  onChange={(event) => {
                    let { value } = event.target;
                    setEmail(value);
                    setEmailError("");
                  }}
                />

                <Button
                  title='ذخیره تغییرات'
                  // margin='100px auto'
                  maxWidth='230px'
                  onClick={() => {
                    handleEdit();
                  }}
                  loading={loader}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ModalEditProfile;
